import React from "react"
import Card from "react-bootstrap/Card"
import { IEvent } from "../../../../types/event"
import styled from "styled-components"
import { twitter } from "../../../../assets"
import { getFormattedDate } from "../../../../services/getFormattedDate"

const CardContent = `  
  background: var(--color-light);
  border: none;
  display: flex;
  justify-content: space-between;
  padding: 10px 15px;

  p {
    margin: 0;
  }
`

const CardHeader = styled(Card.Header)`
  ${CardContent}

  .icon {
    width: 20px;
  }
`

const CardLink = styled(Card.Link)`
  color: black;

  &:hover {
    text-decoration: underline;
    color: var(--color-green);

    img {
      opacity: 0.7;
    }
  }
`

const CardImg = styled(Card.Img)`
  border-top: 1px solid var(--color-light-2);
`

const CardBody = styled(Card.Body)`
  font-family: var(--font-secondary);
  font-size: var(--font-size-sm);
  padding: 5px 15px;

  .link-item {
    font-family: var(--font-primary);
    color: var(--color-dark);
    margin-left: 5px;
  }

  a {
    color: black;

    &:hover {
      text-decoration: underline;
      color: var(--color-green);
    }
  }
`

const CardFooter = styled(Card.Footer)`
  ${CardContent}

  .type, .date {
    font-family: var(--font-secondary);
    font-size: var(--font-size-sm);
    text-transform: capitalize;
  }
  .date {
    font-style: italic;
  }
`

const CardWrapper = styled(Card)`
  margin-bottom: auto;
`

interface IProps {
  item: IEvent
}

const TwitterCard = ({ item }: IProps) => {
  const statusUrl = `https://twitter.com/ateliergeorges/status/${item.id}`
  const hashtagUrl = "https://twitter.com/hashtag/"

  let text = item.text

  // replace url by url + anchor from text
  item.entities?.urls?.forEach(str => {
    text = text.replace(
      str.url,
      `<a href="${str.url}" target="_blank">${str.url}</a>`
    )
  })

  // replace hastag by hastag + anchor from text
  item.entities?.hashtags?.forEach(str => {
    text = text.replace(
      "#" + str.text,
      `<a href="${hashtagUrl}${str.text}" target="_blank">#${str.text}</a>`
    )
  })

  // remove media urls from text
  item.entities?.media?.forEach(str => {
    text = text.replace(str.url, "")
  })

  return (
    <CardWrapper>
      <CardHeader>
        <CardLink href={statusUrl} target="_blank">
          @ateliergeorges
        </CardLink>
        <img className="icon" src={twitter} alt="twitter" />
      </CardHeader>

      <CardBody>
        <div dangerouslySetInnerHTML={{ __html: text }}></div>
      </CardBody>

      <CardFooter>
        <Card.Text className="date">{item.dateFormatted}</Card.Text>
        <CardLink href={statusUrl} target="_blank">
          <Card.Text className="type">{item.type}</Card.Text>
        </CardLink>
      </CardFooter>

      {item.img && (
        <CardLink href={statusUrl} target="_blank">
          <CardImg variant="bottom" src={item.img} />
        </CardLink>
      )}
    </CardWrapper>
  )
}

export default TwitterCard
